import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a1caa8e155f6ff19e3b62f7fd14915622b from "./generated-042335ce-2792-4ebf-8d78-608ae6315d4b.json";

import a1741e60e387b67cc645c49b3d03cb72bb from "./generated-f3a21a99-b2df-4c39-b7e6-cc9214ae0b45.json";

import a9a87a936b348178970a87a1aca2717d9b from "./generated-5febc659-2b93-4a1b-a715-9a16af7cf5b3.json";

import a7d155ecf180728d55ba3d7335cbf2f24b from "./generated-0b42dfc8-5675-4214-aca0-0ecc0a87f2a7.json";

import aea0e52755fcc6da67b0b3ad820366d60b from "./generated-6ecdbcaa-f836-4876-b0e0-b47bae5f0b3c.json";

import a9082c25ba615cb5c6f01a41f2c505fa0b from "./generated-3be5a421-47dd-426e-8720-8ba7da32fb7f.json";

import a4d2d982cb2222243d6202192457c38eab from "./generated-93c947e8-480f-480a-9f64-e340e9ae0d0a.json";

import ab9e2094098acace51ac57ba66b5b5059b from "./generated-216171d7-7086-467a-8b5f-dde1a135ef4c.json";

import a7b95ec49253a2adc45dc25a0c3b704a7b from "./generated-1f9ff994-596b-4306-822d-c4501c5839d2.json";

import a4eb0b730c4f1a4c6cb4c41ce6e9a6439b from "./generated-d2fb2e16-bfdb-4c64-9644-4ad4b2026dbd.json";

import acb6c1ca044ce3738d83be4787f4b846cb from "./generated-d68ccff4-4c44-437a-bf33-2ea1dda078f3.json";

import ac77774b9c1ac0189086d5437aff02238b from "./generated-ca15af2c-fc2a-40c2-b3e6-da267044dbc2.json";

import aa49c4646ba477fc3ac39b8d5e0648423b from "./generated-c05cbba4-ccc2-4606-8fa1-cabf2ea48177.json";

import a01d899fca77f9effd546429b26feb71fb from "./generated-9f00a972-401a-4a96-9278-7e1d9e5fd20b.json";

import aedfaf473f868a3278fa3a1011d9f6b9bb from "./generated-6d2c780d-9120-4986-baf6-53658d645b17.json";

import ae97e276dedc62f28aba5c6cc0c49dc3cb from "./generated-4150eb9b-a265-4db7-93bf-2ba31e0512d0.json";

import ad1abc674368b2a2e36d3d50f7d189970b from "./generated-fa259046-ad50-4933-8cfa-0b0efb07bc80.json";

import a34fe57b59a84a4eb3a3a6363262d1790b from "./generated-63fd7ed3-f268-4c8e-bfff-4a4aa0c1c496.json";

import a9a2866b6877dd713744c5709ac330604b from "./generated-2e7add60-a36c-4378-a9de-54d7241bb0b5.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a1caa8e155f6ff19e3b62f7fd14915622b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a1741e60e387b67cc645c49b3d03cb72bb);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a9a87a936b348178970a87a1aca2717d9b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a7d155ecf180728d55ba3d7335cbf2f24b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(aea0e52755fcc6da67b0b3ad820366d60b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a9082c25ba615cb5c6f01a41f2c505fa0b);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a4d2d982cb2222243d6202192457c38eab);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(ab9e2094098acace51ac57ba66b5b5059b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a7b95ec49253a2adc45dc25a0c3b704a7b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a4eb0b730c4f1a4c6cb4c41ce6e9a6439b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(acb6c1ca044ce3738d83be4787f4b846cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(ac77774b9c1ac0189086d5437aff02238b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(aa49c4646ba477fc3ac39b8d5e0648423b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a01d899fca77f9effd546429b26feb71fb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(aedfaf473f868a3278fa3a1011d9f6b9bb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(ae97e276dedc62f28aba5c6cc0c49dc3cb);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(ad1abc674368b2a2e36d3d50f7d189970b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a34fe57b59a84a4eb3a3a6363262d1790b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a9a2866b6877dd713744c5709ac330604b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(ad1abc674368b2a2e36d3d50f7d189970b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */